import { z } from "zod/v4"

export const userSubject = z.tuple([
  z.union([
    z.literal("manage"),
    z.literal("get"),
    z.literal("update"),
    z.literal("delete"),
  ]),
  z.literal("User"),
])

export type TUserSubject = z.infer<typeof userSubject>
